(() => {
  const layoutEl = document.querySelector('[data-section-id]');
  if (!layoutEl) return;
  const sectionId = layoutEl.dataset.sectionId;

  let categoryNavResizeObserver = null;

  // Horizontal Categories nav (Search & Discovery): scroll arrows + center active link
  function initCategoryNavScroll(root = document.getElementById('collection-categories')) {
    if (!root) return;

    const list = root.querySelector('[data-categories-list]');
    const arrows = root.querySelectorAll('[data-direction]');
    if (!list) return;

    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = list;
      const isOverflowing = scrollWidth > clientWidth + 1;

      root.classList.toggle('collection-categories--overflow', isOverflowing);

      const leftArrow = root.querySelector('[data-direction="left"]');
      const rightArrow = root.querySelector('[data-direction="right"]');

      if (leftArrow) {
        leftArrow.hidden = !isOverflowing;
        leftArrow.classList.toggle('collection-categories__arrow--disabled', scrollLeft <= 1);
      }
      if (rightArrow) {
        rightArrow.hidden = !isOverflowing;
        rightArrow.classList.toggle(
          'collection-categories__arrow--disabled',
          scrollLeft + clientWidth >= scrollWidth - 1
        );
      }
    };

    if (root.dataset.categoriesNavBound === 'true') {
      updateArrows();
      return;
    }
    root.dataset.categoriesNavBound = 'true';

    arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const scrollAmount = list.clientWidth * 0.6;
        const maxScroll = list.scrollWidth - list.clientWidth;
        const direction = arrow.dataset.direction;
        const target = list.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
        list.scrollTo({
          left: Math.min(Math.max(0, target), maxScroll),
          behavior: 'smooth',
        });
      });
    });

    list.addEventListener('scroll', updateArrows, { passive: true });

    if (categoryNavResizeObserver) categoryNavResizeObserver.disconnect();
    categoryNavResizeObserver = new ResizeObserver(updateArrows);
    categoryNavResizeObserver.observe(list);

    root.querySelectorAll('[data-collection-category-link].is-active').forEach((link) => {
      const li = link.closest('li');
      if (!li) return;
      const contentPos = li.offsetLeft - list.offsetLeft;
      const targetScroll = contentPos - list.clientWidth / 2 + li.offsetWidth / 2;
      const maxScroll = list.scrollWidth - list.clientWidth;
      list.scrollTo({
        left: Math.min(Math.max(0, targetScroll), maxScroll),
        behavior: 'auto',
      });
    });

    updateArrows();
  }

  function getCategoryFilterParamName() {
    const nav = document.querySelector('[data-collection-categories]');
    if (nav?.dataset.categoryParam) return nav.dataset.categoryParam;
    const categoryInput = document.querySelector('[data-filter-category]');
    return categoryInput?.name || '';
  }

  function buildSingleCategoryFilterUrl(categoryValue) {
    const url = normalizeCollectionUrl(window.location.href);
    const paramName = getCategoryFilterParamName();
    if (!paramName) return url;

    [...url.searchParams.keys()].forEach((key) => {
      if (key === paramName) url.searchParams.delete(key);
    });

    if (categoryValue) {
      url.searchParams.set(paramName, categoryValue);
    }

    return url;
  }

  function getCategoryNavigateUrl(link) {
    if (link.hasAttribute('data-category-clear')) {
      return buildSingleCategoryFilterUrl(null).toString();
    }

    const categoryValue = link.dataset.categoryValue;
    if (!categoryValue) return link.href;

    if (link.classList.contains('is-active')) {
      return buildSingleCategoryFilterUrl(null).toString();
    }

    return buildSingleCategoryFilterUrl(categoryValue).toString();
  }

  function bindCategoryNavEvents() {
    document.querySelectorAll('[data-collection-category-link]').forEach((link) => {
      if (link.dataset.categoryNavBound === 'true') return;
      link.dataset.categoryNavBound = 'true';

      link.addEventListener('click', (e) => {
        if (link.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        navigateToUrl(getCategoryNavigateUrl(link), { scrollToGrid: true });
      });
    });

    initCategoryNavScroll();
  }

  // Section Rendering API returns updated nav; swap it before the grid to avoid stale filter state
  function swapCategoryNav(doc) {
    const newCategories = doc.getElementById('collection-categories');
    const oldCategories = document.getElementById('collection-categories');
    const anchor = document.querySelector('[data-collection-categories-anchor]');

    if (newCategories && oldCategories) {
      oldCategories.replaceWith(newCategories);
    } else if (newCategories && !oldCategories && anchor) {
      anchor.appendChild(newCategories);
    } else if (!newCategories && oldCategories) {
      oldCategories.remove();
    }
  }

  let form = document.querySelector('[data-filters-form]');
  let formParent = form?.parentElement;
  const filterDrawer = document.getElementById('collection-filters-drawer');
  let drawerBody = document.querySelector('[data-drawer-body]');
  const sortDrawer = document.getElementById('collection-sort-drawer');
  const overlay = document.querySelector('[data-filters-overlay]');
  let activeFilters = document.querySelector('[data-active-filters]');
  if (!form || !formParent) return;

  const mql = window.matchMedia('(max-width: 749px)');
  let fetchController = null;
  let isDrawerOpen = false;

  function getFilterToggleBtn() {
    return document.querySelector('[data-filters-toggle]');
  }

  function getSortToggleBtn() {
    return document.querySelector('[data-sort-toggle]');
  }

  function showOverlay() {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.setAttribute('aria-hidden', 'false'));
  }

  function hideOverlay() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('transitionend', () => { overlay.hidden = true; }, { once: true });
  }

  function openFilterDrawer() {
    drawerBody = document.querySelector('[data-drawer-body]');
    if (!drawerBody || !filterDrawer) return;

    activeFilters = document.querySelector('[data-active-filters]');
    if (activeFilters) drawerBody.appendChild(activeFilters);
    form = document.querySelector('[data-filters-form]');
    formParent = form?.parentElement;
    drawerBody.appendChild(form);
    filterDrawer.hidden = false;
    isDrawerOpen = true;
    requestAnimationFrame(() => filterDrawer.setAttribute('aria-hidden', 'false'));
    getFilterToggleBtn()?.setAttribute('aria-expanded', 'true');
    showOverlay();
    document.body.style.overflow = 'hidden';
  }

  function openSortDrawer() {
    sortDrawer.hidden = false;
    requestAnimationFrame(() => sortDrawer.setAttribute('aria-hidden', 'false'));
    getSortToggleBtn()?.setAttribute('aria-expanded', 'true');
    showOverlay();
    document.body.style.overflow = 'hidden';
  }

  function returnToAside() {
    form = document.querySelector('[data-filters-form]');
    formParent = document.querySelector('[data-filters-aside]');
    activeFilters = document.querySelector('[data-active-filters]');
    drawerBody = document.querySelector('[data-drawer-body]');
    if (!formParent) return;

    if (form && drawerBody?.contains(form)) {
      formParent.appendChild(form);
    }
    if (activeFilters && drawerBody?.contains(activeFilters)) {
      formParent.insertBefore(activeFilters, form || null);
    }
  }

  function closeAll() {
    if (!mql.matches) {
      returnToAside();
    }

    if (filterDrawer && !filterDrawer.hidden) {
      filterDrawer.setAttribute('aria-hidden', 'true');
      isDrawerOpen = false;
      let drawerClosed = false;
      const onDrawerClosed = () => {
        if (drawerClosed) return;
        drawerClosed = true;
        filterDrawer.hidden = true;
        returnToAside();
      };
      filterDrawer.addEventListener('transitionend', onDrawerClosed, { once: true });
      window.setTimeout(onDrawerClosed, 350);
    }
    if (sortDrawer && !sortDrawer.hidden) {
      sortDrawer.setAttribute('aria-hidden', 'true');
      sortDrawer.addEventListener('transitionend', () => { sortDrawer.hidden = true; }, { once: true });
    }
    getFilterToggleBtn()?.setAttribute('aria-expanded', 'false');
    getSortToggleBtn()?.setAttribute('aria-expanded', 'false');
    hideOverlay();
    document.body.style.overflow = '';
  }

  mql.addEventListener('change', (e) => {
    if (!e.matches) {
      returnToAside();
      isDrawerOpen = false;
      if (filterDrawer) { filterDrawer.hidden = true; filterDrawer.removeAttribute('aria-hidden'); }
      if (sortDrawer) { sortDrawer.hidden = true; sortDrawer.removeAttribute('aria-hidden'); }
      if (overlay) { overlay.hidden = true; overlay.removeAttribute('aria-hidden'); }
      getFilterToggleBtn()?.setAttribute('aria-expanded', 'false');
      getSortToggleBtn()?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;

    if (e.target.closest('[data-filters-reset]')) {
      e.preventDefault();
      resetFilters();
      return;
    }

    if (!mql.matches) return;

    const filterBtn = e.target.closest('[data-filters-toggle]');
    if (filterBtn) {
      e.preventDefault();
      openFilterDrawer();
      return;
    }
    if (e.target.closest('[data-sort-toggle]')) {
      e.preventDefault();
      openSortDrawer();
    }
  });

  document.querySelectorAll('[data-filters-close]').forEach((btn) => {
    btn.addEventListener('click', closeAll);
  });

  document.querySelector('[data-drawer-view-items]')?.addEventListener('click', closeAll);

  overlay?.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  function normalizeCollectionUrl(url) {
    const normalized = url instanceof URL ? new URL(url.toString()) : new URL(url, window.location.origin);
    normalized.searchParams.delete('page');
    return normalized;
  }

  function getSortInput() {
    return (
      document.querySelector('[data-sort-toolbar-form] [data-filter-sort]:checked') ||
      document.querySelector('[data-sort-form] [data-filter-sort]:checked')
    );
  }

  function buildFilterUrl() {
    const url = new URL(window.location.pathname, window.location.origin);

    const currentForm = document.querySelector('[data-filters-form]');
    if (!currentForm) return url;

    const sortInput = getSortInput();
    if (sortInput) url.searchParams.set('sort_by', sortInput.value);

    const categoryParam = getCategoryFilterParamName();
    let categoryApplied = false;

    currentForm.querySelectorAll('[data-filter-input]:checked').forEach((input) => {
      if (categoryParam && input.name === categoryParam) {
        if (categoryApplied) return;
        categoryApplied = true;
        url.searchParams.set(input.name, input.value);
        return;
      }
      url.searchParams.append(input.name, input.value);
    });

    const priceRange = currentForm.querySelector('[data-price-range]');
    if (priceRange) {
      const numberMin = currentForm.querySelector('[data-number-min]');
      const numberMax = currentForm.querySelector('[data-number-max]');
      const boundMin = priceRange.dataset.boundMin;
      const boundMax = priceRange.dataset.boundMax;
      if (numberMin && numberMin.value && numberMin.value !== boundMin) {
        url.searchParams.set(numberMin.name, numberMin.value);
      }
      if (numberMax && numberMax.value && numberMax.value !== boundMax) {
        url.searchParams.set(numberMax.name, numberMax.value);
      }
    }

    return url;
  }

  function getGridEl() {
    return document.querySelector('#collection-product-grid');
  }

  async function fetchAndSwap(url, options = {}) {
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    const normalizedUrl = normalizeCollectionUrl(url);
    const shouldScrollToGrid = options.scrollToGrid === true;

    const loadingOverlay = document.createElement('div');
    loadingOverlay.className = 'collection-loading-overlay';
    document.body.appendChild(loadingOverlay);

    const fetchUrl = new URL(normalizedUrl);
    fetchUrl.searchParams.set('sections', sectionId);

    try {
      const response = await fetch(fetchUrl.toString(), { signal: fetchController.signal });
      if (!response.ok) throw new Error(response.statusText);
      const data = await response.json();
      const html = data[sectionId];
      const doc = new DOMParser().parseFromString(html, 'text/html');

      if (options.skipHistory !== true) {
        history.pushState(null, '', normalizedUrl.toString());
      }

      const savedScrollY = window.scrollY;
      const oldFiltersEl = document.querySelector('.collection-filters');
      const savedFiltersScroll = oldFiltersEl ? oldFiltersEl.scrollTop : 0;
      const savedFiltersViewportTop = oldFiltersEl ? oldFiltersEl.getBoundingClientRect().top : null;

      const oldDetails = document.querySelectorAll('[data-filters-form] details.collection-filters__group');
      const detailsOpenState = [...oldDetails].map((d) => d.open);

      const newFiltersAside = doc.querySelector('[data-filters-aside]');
      const oldFiltersAside = document.querySelector('[data-filters-aside]');
      if (newFiltersAside && oldFiltersAside) {
        const wasInDrawer = isDrawerOpen && mql.matches;

        if (wasInDrawer) {
          const oldForm = drawerBody.querySelector('[data-filters-form]');
          const oldChips = drawerBody.querySelector('[data-active-filters]');
          if (oldForm) oldForm.remove();
          if (oldChips) oldChips.remove();
        }

        oldFiltersAside.replaceWith(newFiltersAside);

        const newDetails = newFiltersAside.querySelectorAll('[data-filters-form] details.collection-filters__group');
        detailsOpenState.forEach((wasOpen, i) => {
          if (newDetails[i]) newDetails[i].open = wasOpen;
        });

        if (wasInDrawer) {
          drawerBody = document.querySelector('[data-drawer-body]');
          activeFilters = document.querySelector('[data-active-filters]');
          form = document.querySelector('[data-filters-form]');
          formParent = document.querySelector('[data-filters-aside]');
          if (activeFilters && drawerBody) drawerBody.appendChild(activeFilters);
          if (form && drawerBody) drawerBody.appendChild(form);
          bindFormEvents();
        } else {
          form = document.querySelector('[data-filters-form]');
          formParent = form?.parentElement;
          activeFilters = document.querySelector('[data-active-filters]');
          bindFormEvents();
        }

        if (!mql.matches) {
          returnToAside();
        }
      }

      swapCategoryNav(doc);

      const newToolbar = doc.querySelector('[data-collection-sort-toolbar]');
      const oldToolbar = document.querySelector('[data-collection-sort-toolbar]');
      if (newToolbar && oldToolbar) {
        oldToolbar.replaceWith(newToolbar);
      }

      const newSortForm = doc.querySelector('[data-sort-form]');
      const oldSortForm = document.querySelector('[data-sort-form]');
      if (newSortForm && oldSortForm) {
        oldSortForm.replaceWith(newSortForm);
      }

      const newGrid = doc.querySelector('#collection-product-grid');
      const oldGrid = getGridEl();
      if (newGrid && oldGrid) {
        oldGrid.replaceWith(newGrid);
      }

      if (!shouldScrollToGrid) {
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo(0, Math.min(savedScrollY, maxScroll));

        requestAnimationFrame(() => {
          const filtersEl = document.querySelector('.collection-filters');
          if (filtersEl) filtersEl.scrollTop = savedFiltersScroll;

          if (savedFiltersViewportTop != null && filtersEl) {
            const delta = filtersEl.getBoundingClientRect().top - savedFiltersViewportTop;
            if (Math.abs(delta) > 1) {
              window.scrollBy(0, delta);
            }
          }
        });
      } else {
        const newFiltersEl = document.querySelector('.collection-filters');
        if (newFiltersEl) {
          newFiltersEl.scrollTop = savedFiltersScroll;
        }
      }

      const newDrawer = doc.querySelector('#collection-filters-drawer');
      if (newDrawer) {
        filterDrawer.className = newDrawer.className;
        const newFooter = newDrawer.querySelector('.collection-filters__drawer-footer');
        const oldFooter = filterDrawer.querySelector('.collection-filters__drawer-footer');
        if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
        bindDrawerFooterEvents();
      }

      bindChipEvents();
      bindCategoryNavEvents();
      bindSortToolbarEvents();
      bindSortFormEvents();

      document.dispatchEvent(new CustomEvent('grid:updated'));

      if (mql.matches && !isDrawerOpen) closeAll();

      if (shouldScrollToGrid) {
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        if (window.scrollY > maxScroll) {
          window.scrollTo(0, maxScroll);
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.dispatchEvent(new CustomEvent('collection:scroll-to-grid'));
          });
        });
      }
    } catch (e) {
      if (e.name !== 'AbortError') {
        window.location.href = normalizedUrl.toString();
      }
    } finally {
      fetchController = null;
      loadingOverlay.remove();
    }
  }

  function submitFilters() {
    const url = buildFilterUrl();
    fetchAndSwap(url);
  }

  function resetFilters() {
    const url = new URL(window.location.pathname, window.location.origin);
    fetchAndSwap(url);
  }

  function navigateToUrl(targetUrl, options = {}) {
    const url = new URL(targetUrl, window.location.origin);
    fetchAndSwap(url, options);
  }

  function bindFormEvents() {
    const currentForm = document.querySelector('[data-filters-form]');
    if (!currentForm) return;

    currentForm.addEventListener('change', (e) => {
      if (e.target.matches('[data-filter-input]')) {
        submitFilters();
      }
    });

    currentForm.addEventListener('price-range:change', () => {
      submitFilters();
    });
  }

  function bindChipEvents() {
    const chips = document.querySelectorAll('[data-active-filters] .collection-filters__chip');
    chips.forEach((chip) => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        navigateToUrl(chip.href);
      });
    });
  }

  function bindDrawerFooterEvents() {
    const viewBtn = filterDrawer.querySelector('[data-drawer-view-items]');
    viewBtn?.addEventListener('click', closeAll);
  }

  function bindSortToolbarEvents() {
    const toolbarForm = document.querySelector('[data-sort-toolbar-form]');
    if (!toolbarForm || toolbarForm.dataset.sortToolbarBound === 'true') return;
    toolbarForm.dataset.sortToolbarBound = 'true';

    toolbarForm.addEventListener('change', (e) => {
      if (!e.target.matches('[data-filter-sort]')) return;
      const dropdown = toolbarForm.closest('details');
      if (dropdown) dropdown.open = false;
      submitFilters();
    });
  }

  function bindSortFormEvents() {
    const sortForm = document.querySelector('[data-sort-form]');
    if (!sortForm || sortForm.dataset.sortFormBound === 'true') return;
    sortForm.dataset.sortFormBound = 'true';

    sortForm.addEventListener('change', (e) => {
      if (e.target.matches('[data-filter-sort]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        fetchAndSwap(url);
        if (mql.matches) closeAll();
      }
    });
  }

  if (!mql.matches) {
    returnToAside();
  }

  bindFormEvents();
  bindChipEvents();
  bindCategoryNavEvents();
  bindDrawerFooterEvents();
  bindSortToolbarEvents();
  bindSortFormEvents();

  window.addEventListener('popstate', () => {
    const url = new URL(window.location.href);
    fetchAndSwap(url, { skipHistory: true });
  });

  document.addEventListener('collection:navigate', (e) => {
    const url = new URL(e.detail.url, window.location.origin);
    fetchAndSwap(url, { scrollToGrid: e.detail.scrollToGrid !== false });
  });

  if (customElements.get('price-range')) return;

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.onRangeInput = this.onRangeInput.bind(this);
      this.onRangeChange = this.onRangeChange.bind(this);
      this.onNumberChange = this.onNumberChange.bind(this);
      this.onNumberFocus = this.onNumberFocus.bind(this);
    }

    connectedCallback() {
      this.rangeMin = this.querySelector('[data-range-min]');
      this.rangeMax = this.querySelector('[data-range-max]');
      this.numberMin = this.querySelector('[data-number-min]');
      this.numberMax = this.querySelector('[data-number-max]');
      this.fill = this.querySelector('[data-price-fill]');

      this.rangeMin.addEventListener('input', this.onRangeInput);
      this.rangeMax.addEventListener('input', this.onRangeInput);
      this.rangeMin.addEventListener('change', this.onRangeChange);
      this.rangeMax.addEventListener('change', this.onRangeChange);
      this.numberMin.addEventListener('change', this.onNumberChange);
      this.numberMax.addEventListener('change', this.onNumberChange);
      this.numberMin.addEventListener('focus', this.onNumberFocus);
      this.numberMax.addEventListener('focus', this.onNumberFocus);

      this.updateFill();
    }

    disconnectedCallback() {
      this.rangeMin.removeEventListener('input', this.onRangeInput);
      this.rangeMax.removeEventListener('input', this.onRangeInput);
      this.rangeMin.removeEventListener('change', this.onRangeChange);
      this.rangeMax.removeEventListener('change', this.onRangeChange);
      this.numberMin.removeEventListener('change', this.onNumberChange);
      this.numberMax.removeEventListener('change', this.onNumberChange);
      this.numberMin.removeEventListener('focus', this.onNumberFocus);
      this.numberMax.removeEventListener('focus', this.onNumberFocus);
    }

    get minBound() { return parseFloat(this.rangeMin.min); }
    get maxBound() { return parseFloat(this.rangeMax.max); }

    onNumberFocus(e) {
      e.target.select();
    }

    onRangeInput(e) {
      let minVal = parseFloat(this.rangeMin.value);
      let maxVal = parseFloat(this.rangeMax.value);

      if (e.target === this.rangeMin && minVal > maxVal) {
        this.rangeMin.value = maxVal;
        minVal = maxVal;
      } else if (e.target === this.rangeMax && maxVal < minVal) {
        this.rangeMax.value = minVal;
        maxVal = minVal;
      }

      this.numberMin.value = Math.round(minVal);
      this.numberMax.value = Math.round(maxVal);
      this.updateFill();
    }

    onRangeChange() {
      this.numberMin.value = Math.round(parseFloat(this.rangeMin.value));
      this.numberMax.value = Math.round(parseFloat(this.rangeMax.value));
      this.dispatchEvent(new CustomEvent('price-range:change', { bubbles: true }));
    }

    onNumberChange() {
      let minVal = parseFloat(this.numberMin.value);
      let maxVal = parseFloat(this.numberMax.value);
      if (Number.isNaN(minVal)) minVal = this.minBound;
      if (Number.isNaN(maxVal)) maxVal = this.maxBound;
      minVal = Math.min(Math.max(minVal, this.minBound), maxVal);
      maxVal = Math.min(Math.max(maxVal, minVal), this.maxBound);
      this.rangeMin.value = minVal;
      this.rangeMax.value = maxVal;
      this.numberMin.value = Math.round(minVal);
      this.numberMax.value = Math.round(maxVal);
      this.updateFill();
      this.dispatchEvent(new CustomEvent('price-range:change', { bubbles: true }));
    }

    resetToDefaults() {
      this.rangeMin.value = this.minBound;
      this.rangeMax.value = this.maxBound;
      this.numberMin.value = '';
      this.numberMax.value = '';
      this.updateFill();
    }

    updateFill() {
      const range = this.maxBound - this.minBound;
      if (range === 0) return;
      const minPct = ((parseFloat(this.rangeMin.value) - this.minBound) / range) * 100;
      const maxPct = ((parseFloat(this.rangeMax.value) - this.minBound) / range) * 100;
      this.fill.style.left = `${minPct}%`;
      this.fill.style.width = `${maxPct - minPct}%`;
      const isTouching = minPct === maxPct;
      this.classList.toggle('is-touching', isTouching);
      this.classList.toggle('is-touching-left-edge', isTouching && minPct <= 0);
      this.classList.toggle('is-touching-right-edge', isTouching && maxPct >= 100);
      this.numberMin.toggleAttribute('data-active', Math.round(parseFloat(this.rangeMin.value)) !== Math.round(this.minBound));
      this.numberMax.toggleAttribute('data-active', Math.round(parseFloat(this.rangeMax.value)) !== Math.round(this.maxBound));
    }
  }

  customElements.define('price-range', PriceRange);
})();
